export const selectInterestBalance = state => state.interestBalance;

// FISCAL
export const selectFiscalInterestBalance = state =>
  selectInterestBalance(state).fiscal;
export const selectFiscalInterestBalanceList = state =>
  selectFiscalInterestBalance(state).items;
export const selectFiscalInterestBalanceListCount = state =>
  selectFiscalInterestBalance(state).count;
export const selectFiscalInterestBalanceQueryOptions = state => {
  const { options } = selectFiscalInterestBalance(state);

  const cleanedOptions = { ...options };
  Object.keys(cleanedOptions).forEach(key => {
    if (cleanedOptions[key] === '') {
      delete cleanedOptions[key];
    }
  });

  return cleanedOptions;
};

// ACCOUTING

export const selectAccountingInterestBalance = state =>
  selectInterestBalance(state).accounting;

export const selectAccountingInterestBalanceList = state =>
  selectAccountingInterestBalance(state).items;

export const selectAccountingInterestBalanceListCount = state =>
  selectAccountingInterestBalance(state).count;

export const selectAccountingInterestBalanceQueryOptions = state => {
  const { options } = selectAccountingInterestBalance(state);

  const cleanedOptions = { ...options };
  Object.keys(cleanedOptions).forEach(key => {
    if (cleanedOptions[key] === '') {
      delete cleanedOptions[key];
    }
  });

  return cleanedOptions;
};
